export default __webpack_public_path__ + "static/ukraine-flag-61aa0f80a67a43eb4779d1c3538f04b5.svg";